module.exports = __webpack_public_path__ + "static/media/480.68106ba5.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-garden-shears/light/480.png
// module id = 2116
// module chunks = 2